@if (redirectAction(); as action) {
  @if (redirectUrl(); as url) {
    <a
      [href]="url"
      target="_blank"
      rel="noopener noreferrer"
      class="flex items-center justify-center rounded focus-visible:outline-2 focus-visible:outline-primary-purple"
      [attr.aria-label]="literalService.get(action.labelKey, true) + ' (' + literalService.get('openInNewTab') + ')'"
      [tooltip]="literalService.get(action.labelKey, true)"
      [position]="tooltipPosition()"
      (click)="stopRowSelection($event)"
    >
      <img [src]="action.icon" alt="" aria-hidden="true" class="block h-6 w-6" />
    </a>
  }
}
